<template>
  <div class="home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>
<style lang="scss" scoped>
.home {
  background-color: #dadada !important;
  height: 100vh;
}
</style>
